import { useCallback } from "react";

export type HapticPattern = "light" | "medium" | "heavy" | "success" | "error";

const patterns: Record<HapticPattern, number | number[]> = {
  light: 10,
  medium: 20,
  heavy: 40,
  success: [10, 50, 10],
  error: [20, 40, 20, 40, 20],
};

function canVibrate(): boolean {
  return typeof navigator !== "undefined" && "vibrate" in navigator;
}

/**
 * Triggers haptic feedback via the Vibration API (Android browsers).
 * iOS Safari does not support `navigator.vibrate` — this is a no-op there.
 *
 * Usage:
 *   const haptic = useHapticFeedback();
 *   <button onPointerDown={() => haptic("light")} />
 */
export function useHapticFeedback() {
  return useCallback((pattern: HapticPattern = "light") => {
    if (canVibrate()) {
      navigator.vibrate(patterns[pattern]);
    }
  }, []);
}

/** Non-hook version for use outside React (event handlers, side-effects). */
export function triggerHaptic(pattern: HapticPattern = "light"): void {
  if (canVibrate()) {
    navigator.vibrate(patterns[pattern]);
  }
}
